export const isMobile = (userAgent: string) => /Mobi|Android/i.test(userAgent);

export const isIOSMobileDevice = () => {
  const userAgent = navigator.userAgent;
  return /iPhone|iPod|iPad/i.test(userAgent) && /Mobile/i.test(userAgent);
};
